import { render, staticRenderFns } from "./VTableHeaders.vue?vue&type=template&id=0e82e9b2"
import script from "./VTableHeaders.vue?vue&type=script&lang=js"
export * from "./VTableHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e82e9b2')) {
      api.createRecord('0e82e9b2', component.options)
    } else {
      api.reload('0e82e9b2', component.options)
    }
    module.hot.accept("./VTableHeaders.vue?vue&type=template&id=0e82e9b2", function () {
      api.rerender('0e82e9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VTable/VTableHeaders.vue"
export default component.exports